import { HashRouter as Router, Routes, Route } from "react-router-dom";
import { Shell } from "./components/commons/Layout";
import { Home } from "./components/specific/Home";
import { Servicios } from "./components/specific/Servicios";
import { SobreNosotros } from "./components/specific/SobreNosotros";
import { Contacto } from "./components/specific/Contacto";

export default function App() {
  return (
    <Router>
      <Shell>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/servicios" element={<Servicios />} />
          <Route path="/sobre-nosotros" element={<SobreNosotros />} />
          <Route path="/contacto" element={<Contacto />} />
        </Routes>
      </Shell>
    </Router>
  );
}
